import * as T from '@radix-ui/react-tooltip';
import { cn } from '../lib/cn';

export function TooltipProvider({ children, delayDuration = 150 }) {
  return <T.Provider delayDuration={delayDuration}>{children}</T.Provider>;
}

export const Tooltip = T.Root;
export const TooltipTrigger = T.Trigger;

export function TooltipContent({ className, side = 'top', sideOffset = 6, ...props }) {
  return (
    <T.Portal>
      <T.Content
        side={side}
        sideOffset={sideOffset}
        className={cn(
          'z-50 rounded-md border border-[hsl(var(--border))] bg-[hsl(var(--card))] px-2 py-1 text-xs text-[hsl(var(--fg))] shadow-elev-2',
          className
        )}
        {...props}
      />
    </T.Portal>
  );
}
